import { render } from "./Placement.vue?vue&type=template&id=470ccf04"
import script from "./Placement.vue?vue&type=script&lang=js"
export * from "./Placement.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__